'use client';

import React, { useState, useEffect } from 'react';
import classNames from 'classnames';


// Import Styles
import styles from './submitButton.module.scss';

interface SubmitButtonProps {
  label: string;
  type?: 'submit' | 'button' | 'reset';
  loading?: boolean;
  loadingLabel?: string;
  disabled?: boolean;
  className?: string;
  handleClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  ariaPressed?: boolean;
  ariaControls?: string;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  label,
  type = 'submit',
  loading = false,
  loadingLabel = 'Submitting',
  disabled = false,
  className,
  handleClick,
  ariaPressed = false,
  ariaControls = ''
}) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        setDots((prev) => (prev.length < 3 ? prev + '.' : ''));
      }, 500);
      return () => clearInterval(interval);
    } else {
      setDots('');
    }
  }, [loading]);

  return (
    <button
      type={type}
      className={classNames(
        styles.submitButton,
        {
          [styles.disabled]: disabled && !loading,
          [styles.loading]: loading
        },
        className
      )}
      // Only prevent click if loading (so you can't double-submit)
      disabled={loading}
      data-disabled={disabled && !loading ? 'true' : undefined}
      onClick={handleClick}
      aria-pressed={ariaPressed}
      aria-controls={ariaControls}
    >
      {loading ? (<>{loadingLabel}<span className={styles.dots}>{dots}</span></>) : label}
    </button>
  );
};

export default SubmitButton;
